import { produce } from "immer";
import { addPlaceholderMetadataToCimDoc, isUnreplacedPlaceholderImage } from "@design-stack-vista/studio-document-metadata-management";
export const removeUnreplacedPlaceholdersFromCimDoc = (cimDoc) => {
    const newDocument = addPlaceholderMetadataToCimDoc(cimDoc);
    return produce(newDocument, draftCimdoc => {
        var _a, _b, _c;
        const placeholderImageIds = ((_c = (_b = (_a = newDocument.metadata) === null || _a === void 0 ? void 0 : _a.template) === null || _b === void 0 ? void 0 : _b.filter(isUnreplacedPlaceholderImage)) !== null && _c !== void 0 ? _c : []).map(imageTemplate => imageTemplate.id);
        draftCimdoc.document.panels.forEach(panel => {
            var _a, _b;
            // Remove any images from the document that are placeholder images
            panel.images = (_b = (_a = panel.images) === null || _a === void 0 ? void 0 : _a.filter(image => !placeholderImageIds.includes(image.id))) !== null && _b !== void 0 ? _b : [];
        });
    });
};
//# sourceMappingURL=removeUnreplacedPlaceholdersFromCimDoc.js.map